import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/**
 * Daily Gale HSA/FSA payment totals for the authenticated team, queried live
 * from Shopify's payments report and normalized to the shop currency.
 */
export const getHsaPaymentAnalytics = {
  name: "getHsaPaymentAnalytics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    series: z.array(
      z.object({ date: z.string(), orders: z.number(), gross: z.number() }),
    ),
    totalOrders: z.number(),
    totalGross: z.number(),
    shopCurrency: createEnum(Currency),
    /** False when Redo lacks the read_reports scope or the query failed. */
    reporting: z.boolean(),
  }),
};
